import {
    TICKET_LIST_DATA,
    TICKET_DETAILS_DATA,
    TICKET_INSIGHT_DETAILS_DATA,
    TICKET_ARTICLE_DATA,
    TICKET_DETAILS_ADD_DATA,
    TICKET_MESSAGE_ADD_DATA,
    TICKET_SOLUTION_ADD_DATA,
    GET_USER_TICKET_FILTER_DATA,
    USER_TICKET_FILTER_ADD_DATA,
    USER_TICKET_FILTER_DELETE_DATA,
    ADMIN_TICKETS,
    WORKFLOW_DETAILS_DATA,
    MESSAGE_TEMPLATE_DROPDOWN,  
    TICKET_FILTER_DATA,
    WORKFLOW_DETAILS_ADD_DATA,
    TICKET_DELETE_DATA,
    WORKFLOW_DELETE_DATA,
    TICKET_BULK_UPDATE_DATA,
    TICKET_ERROR_LOG_DATA,
    TICKET_EMAIL_EXECUTION_LOG_DATA,
    TICKET_DASHBOARD_METRIC_DATA,
    TICKET_ATTACHMENT_ADD_DATA,
    TICKET_ATTACHMENT_DELETE_DATA,
  
} from './Constants'

// get all ticket listing
const loadTicketListGetDataRequest = () => ({
  type: TICKET_LIST_DATA.TICKET_LIST_DATA_LOAD,
});
const setTicketListGetDataSuccess = (ticketlist) => ({
  type: TICKET_LIST_DATA.TICKET_LIST_DATA_SUCCESS,
  ticketlist,
});
const setTicketListGetDataFail = (error) => ({
  type: TICKET_LIST_DATA.TICKET_LIST_DATA_FAIL,
  error,
});

//Get by id
const loadTicketDetailsGetDataRequest = (id) => ({
  type: TICKET_DETAILS_DATA.TICKET_DETAILS_DATA_LOAD,
  id,
});

const setTicketDetailsGetDataSuccess = (ticketdetails) => ({
  type: TICKET_DETAILS_DATA.TICKET_DETAILS_DATA_SUCCESS,
  ticketdetails,
});

const setTicketDetailsGetDataFail = (error) => ({
  type: TICKET_DETAILS_DATA.TICKET_DETAILS_DATA_FAIL,
  error,
});

//Get insight by id
const loadTicketInsightDetailsGetDataRequest = (id) => ({
  type: TICKET_INSIGHT_DETAILS_DATA.TICKET_INSIGHT_DETAILS_DATA_LOAD,
  id,
});

const setTicketInsightDetailsGetDataSuccess = (insights) => ({
  type: TICKET_INSIGHT_DETAILS_DATA.TICKET_INSIGHT_DETAILS_DATA_SUCCESS,
  insights,
});

const setTicketInsightDetailsGetDataFail = (error) => ({
  type: TICKET_INSIGHT_DETAILS_DATA.TICKET_INSIGHT_DETAILS_DATA_FAIL,
  error,
});

//Get workflow details by id
const loadWorkflowDetailsGetDataRequest = (id) => ({
  type: WORKFLOW_DETAILS_DATA.WORKFLOW_DETAILS_DATA_LOAD,
  id,
});

const setWorkflowDetailsGetDataSuccess = (workflowdetails) => ({
  type: WORKFLOW_DETAILS_DATA.WORKFLOW_DETAILS_DATA_SUCCESS,
  workflowdetails,
});

const setWorkflowDetailsGetDataFail = (error) => ({
  type: WORKFLOW_DETAILS_DATA.WORKFLOW_DETAILS_DATA_FAIL,
  error,
});

//Get article by id
const loadTicketArticleGetDataRequest = (id) => ({
  type: TICKET_ARTICLE_DATA.TICKET_ARTICLE_DATA_LOAD,
  id,
});

const setTicketArticleGetDataSuccess = (article) => ({
  type: TICKET_ARTICLE_DATA.TICKET_ARTICLE_DATA_SUCCESS,
  article,
});

const setTicketArticleGetDataFail = (error) => ({
  type: TICKET_ARTICLE_DATA.TICKET_ARTICLE_DATA_FAIL,
  error,
});

//For ticket details save
const loadTicketDetailsAddDataRequest = (request) => ({
  type: TICKET_DETAILS_ADD_DATA.TICKET_DETAILS_ADD_DATA_LOAD,
  request,
});
const setTicketDetailsAddDataSuccess = (tickets) => ({
  type: TICKET_DETAILS_ADD_DATA.TICKET_DETAILS_ADD_DATA_SUCCESS,
  tickets,
});
const setTicketDetailsAddDataFail = (error) => ({
  type: TICKET_DETAILS_ADD_DATA.TICKET_DETAILS_ADD_DATA_FAIL,
  error,
});

//For ticket message save
const loadTicketMessageAddDataRequest = (request) => ({
  type: TICKET_MESSAGE_ADD_DATA.TICKET_MESSAGE_ADD_DATA_LOAD,
  request,
});
const setTicketMessageAddDataSuccess = (message) => ({
  type: TICKET_MESSAGE_ADD_DATA.TICKET_MESSAGE_ADD_DATA_SUCCESS,
  message,
});
const setTicketMessageAddDataFail = (error) => ({
  type: TICKET_MESSAGE_ADD_DATA.TICKET_MESSAGE_ADD_DATA_FAIL,
  error,
});

//For ticket solution save
const loadTicketSolutionAddDataRequest = (request) => ({
  type: TICKET_SOLUTION_ADD_DATA.TICKET_SOLUTION_ADD_DATA_LOAD,
  request,
});
const setTicketSolutionAddDataSuccess = (solution) => ({
  type: TICKET_SOLUTION_ADD_DATA.TICKET_SOLUTION_ADD_DATA_SUCCESS,
  solution,
});
const setTicketSolutionAddDataFail = (error) => ({
  type: TICKET_SOLUTION_ADD_DATA.TICKET_SOLUTION_ADD_DATA_FAIL,
  error,
});

 const loadUserTicketFilterGetDataRequest = (filterType) => ({
  type: GET_USER_TICKET_FILTER_DATA.TICKET_FILTER_DETAILS_DATA_LOAD,
  filterType,
});

 const setUserTicketFilterGetDataSuccess = (filterData) => ({
  type: GET_USER_TICKET_FILTER_DATA.TICKET_FILTER_DETAILS_DATA_SUCCESS,
  filterData,
});

 const setUserTicketFilterGetDataFail = (error) => ({
  type: GET_USER_TICKET_FILTER_DATA.TICKET_FILTER_DETAILS_DATA_FAIL,
  error,
});

// ADD USER FILTER DATA ACTIONS
 const loadUserTicketFilterAddDataRequest = (request) => ({
  type: USER_TICKET_FILTER_ADD_DATA.TICKET_FILTER_ADD_DATA_LOAD,
  request,
});

 const setUserTicketFilterAddDataSuccess = (response) => ({
  type: USER_TICKET_FILTER_ADD_DATA.TICKET_FILTER_ADD_DATA_SUCCESS,
  response,
});

 const setUserTicketFilterAddDataFail = (error) => ({
  type: USER_TICKET_FILTER_ADD_DATA.TICKET_FILTER_ADD_DATA_FAIL,
  error,
});

// DELETE – request
 const loadUserTicketFilterDeleteDataRequest = (id) => ({
  type: USER_TICKET_FILTER_DELETE_DATA.TICKET_FILTER_DELETE_DATA_LOAD,
  id,
});

// DELETE – success
 const setUserTicketFilterDeleteDataSuccess = (id) => ({
  type: USER_TICKET_FILTER_DELETE_DATA.TICKET_FILTER_DELETE_DATA_SUCCESS,
  id,
});

// DELETE – fail
 const setUserTicketFilterDeleteDataFail = (error) => ({
  type: USER_TICKET_FILTER_DELETE_DATA.TICKET_FILTER_DELETE_DATA_FAIL,
  error,
});

// QUERY LIST
 const loadAdminTicketsQueryRequest = (payload) => ({
  type: ADMIN_TICKETS.QUERY_LOAD,
  payload,
});

 const setAdminTicketsQuerySuccess = (data) => ({
  type: ADMIN_TICKETS.QUERY_SUCCESS,
  data,
});

 const setAdminTicketsQueryFail = (error) => ({
  type: ADMIN_TICKETS.QUERY_FAIL,
  error,
});

// ROWCOUNT
 const loadAdminTicketsRowCountRequest = (payload) => ({
  type: ADMIN_TICKETS.ROWCOUNT_LOAD,
  payload,
});

 const setAdminTicketsRowCountSuccess = (data) => ({
  type: ADMIN_TICKETS.ROWCOUNT_SUCCESS,
  data,
});

 const setAdminTicketsRowCountFail = (error) => ({
  type: ADMIN_TICKETS.ROWCOUNT_FAIL,
  error,
});

const loadMessageTemplateDropdown = (templateType = "messages") => ({
  type: MESSAGE_TEMPLATE_DROPDOWN.MESSAGE_TEMPLATE_DROPDOWN_LOAD,
  templateType,
});

const setMessageTemplateDropdownSuccess = (data) => ({
  type: MESSAGE_TEMPLATE_DROPDOWN.MESSAGE_TEMPLATE_DROPDOWN_SUCCESS,
  payload: data,
});

const setMessageTemplateDropdownFail = (error) => ({
  type: MESSAGE_TEMPLATE_DROPDOWN.MESSAGE_TEMPLATE_DROPDOWN_FAIL,
  error,
});

// Save ticket filter
const loadTicketFilterSaveDataRequest = (request) => ({
  type: TICKET_FILTER_DATA.TICKET_FILTER_DATA_LOAD,
  request,
});
const setTicketFilterSaveDataSuccess = (filterlist) => ({
  type: TICKET_FILTER_DATA.TICKET_FILTER_DATA_SUCCESS,
  filterlist,
});
const setTicketFilterSaveDataFail = (error) => ({
  type: TICKET_FILTER_DATA.TICKET_FILTER_DATA_FAIL,
  error,
});
//For  workflow details save
const loadWorkflowDetailsAddDataRequest = (request) => ({
  type: WORKFLOW_DETAILS_ADD_DATA.WORKFLOW_DETAILS_ADD_DATA_LOAD,
  request,
});
const setWorkflowDetailsAddDataSuccess = (workflows) => ({
  type: WORKFLOW_DETAILS_ADD_DATA.WORKFLOW_DETAILS_ADD_DATA_SUCCESS,
  workflows,
});
const setWorkflowDetailsAddDataFail = (error) => ({
  type: WORKFLOW_DETAILS_ADD_DATA.WORKFLOW_DETAILS_ADD_DATA_FAIL,
  error,
});
// Delete Ticket
const loadTicketDeleteDataRequest = (id) => ({
  type: TICKET_DELETE_DATA.TICKET_DELETE_LOAD,
  id,
});
const setTicketDeleteDataSuccess = (ticket) => ({
  type: TICKET_DELETE_DATA.TICKET_DELETE_SUCCESS,
  ticket,
});

const setTicketDeleteDataFail = (error) => ({
  type: TICKET_DELETE_DATA.TICKET_DELETE_FAIL,
  error,
});
// Delete workflow
const loadWorkflowDeleteDataRequest = (id) => ({
  type: WORKFLOW_DELETE_DATA.WORKFLOW_DELETE_LOAD,
  id,
});
const setWorkflowDeleteDataSuccess = (workflow) => ({
  type: WORKFLOW_DELETE_DATA.WORKFLOW_DELETE_SUCCESS,
  workflow,
});

const setWorkflowDeleteDataFail = (error) => ({
  type: WORKFLOW_DELETE_DATA.WORKFLOW_DELETE_FAIL,
  error,
});

// bulk update

const loadTicketBulkUpdateRequest = (payload) => ({
  type: TICKET_BULK_UPDATE_DATA.TICKET_BULK_UPDATE_LOAD,
  payload,
});
const setTicketBulkUpdateSuccess = (data) => ({
  type: TICKET_BULK_UPDATE_DATA.TICKET_BULK_UPDATE_SUCCESS,
  data,
});
const setTicketBulkUpdateFail = (error) => ({
  type: TICKET_BULK_UPDATE_DATA.TICKET_BULK_UPDATE_FAIL,
  error,
});
// Error logs
const loadTicketErrorLogGetDataRequest = () => ({
  type: TICKET_ERROR_LOG_DATA.TICKET_ERROR_LOG_DATA_LOAD,
});
const setTicketErrorLogGetDataSuccess = (errorLogs) => ({
  type: TICKET_ERROR_LOG_DATA.TICKET_ERROR_LOG_DATA_SUCCESS,
  errorLogs,
});
const setTicketErrorLogGetDataFail = (error) => ({
  type: TICKET_ERROR_LOG_DATA.TICKET_ERROR_LOG_DATA_FAIL,
  error,
});
// email execution logs
const loadTicketEmailExecutionLogGetDataRequest = () => ({
  type: TICKET_EMAIL_EXECUTION_LOG_DATA.TICKET_EMAIL_EXECUTION_LOG_DATA_LOAD,
});
const setTicketEmailExecutionLogGetDataSuccess = (emailExecutionLogs) => ({
  type: TICKET_EMAIL_EXECUTION_LOG_DATA.TICKET_EMAIL_EXECUTION_LOG_DATA_SUCCESS,
  emailExecutionLogs,
});
const setTicketEmailExecutionLogGetDataFail = (error) => ({
  type: TICKET_EMAIL_EXECUTION_LOG_DATA.TICKET_EMAIL_EXECUTION_LOG_DATA_FAIL,
  error,
});
// get dashboard metric
const loadTicketDashboardMetricGetDataRequest = () => ({
  type: TICKET_DASHBOARD_METRIC_DATA.TICKET_DASHBOARD_METRIC_DATA_LOAD,
});
const setTicketDashboardMetricGetDataSuccess = (dashboardmetrics) => ({
  type: TICKET_DASHBOARD_METRIC_DATA.TICKET_DASHBOARD_METRIC_DATA_SUCCESS,
  dashboardmetrics,
});
const setTicketDashboardMetricGetDataFail = (error) => ({
  type: TICKET_DASHBOARD_METRIC_DATA.TICKET_DASHBOARD_METRIC_DATA_FAIL,
  error,
});

// Attachment add (standalone upload)
const loadTicketAttachmentAddDataRequest = (request) => ({
  type: TICKET_ATTACHMENT_ADD_DATA.TICKET_ATTACHMENT_ADD_DATA_LOAD,
  request,
});
const setTicketAttachmentAddDataSuccess = (attachment) => ({
  type: TICKET_ATTACHMENT_ADD_DATA.TICKET_ATTACHMENT_ADD_DATA_SUCCESS,
  attachment,
});
const setTicketAttachmentAddDataFail = (error) => ({
  type: TICKET_ATTACHMENT_ADD_DATA.TICKET_ATTACHMENT_ADD_DATA_FAIL,
  error,
});

// Attachment delete
const loadTicketAttachmentDeleteDataRequest = (ticketId, fileId) => ({
  type: TICKET_ATTACHMENT_DELETE_DATA.TICKET_ATTACHMENT_DELETE_LOAD,
  ticketId,
  fileId,
});
const setTicketAttachmentDeleteDataSuccess = (fileId) => ({
  type: TICKET_ATTACHMENT_DELETE_DATA.TICKET_ATTACHMENT_DELETE_SUCCESS,
  fileId,
});
const setTicketAttachmentDeleteDataFail = (error) => ({
  type: TICKET_ATTACHMENT_DELETE_DATA.TICKET_ATTACHMENT_DELETE_FAIL,
  error,
});

export {
    loadTicketListGetDataRequest,setTicketListGetDataFail,setTicketListGetDataSuccess,
    loadTicketDetailsGetDataRequest,setTicketDetailsGetDataSuccess,setTicketDetailsGetDataFail,
    loadTicketInsightDetailsGetDataRequest, setTicketInsightDetailsGetDataSuccess, setTicketInsightDetailsGetDataFail, 
    loadTicketArticleGetDataRequest, setTicketArticleGetDataSuccess ,setTicketArticleGetDataFail, 
    loadTicketDetailsAddDataRequest, setTicketDetailsAddDataSuccess ,setTicketDetailsAddDataFail,
    loadTicketMessageAddDataRequest, setTicketMessageAddDataSuccess ,setTicketMessageAddDataFail,
    loadTicketSolutionAddDataRequest, setTicketSolutionAddDataSuccess,setTicketSolutionAddDataFail,
    loadUserTicketFilterGetDataRequest, setUserTicketFilterGetDataSuccess, setUserTicketFilterGetDataFail,
    loadUserTicketFilterAddDataRequest, setUserTicketFilterAddDataSuccess, setUserTicketFilterAddDataFail,
    loadUserTicketFilterDeleteDataRequest, setUserTicketFilterDeleteDataSuccess, setUserTicketFilterDeleteDataFail,
    loadAdminTicketsQueryRequest, setAdminTicketsQuerySuccess, setAdminTicketsQueryFail,
    loadAdminTicketsRowCountRequest, setAdminTicketsRowCountSuccess, setAdminTicketsRowCountFail,
    loadWorkflowDetailsGetDataRequest,setWorkflowDetailsGetDataSuccess,setWorkflowDetailsGetDataFail,
    loadMessageTemplateDropdown, setMessageTemplateDropdownSuccess, setMessageTemplateDropdownFail,
    loadTicketFilterSaveDataRequest, setTicketFilterSaveDataSuccess ,setTicketFilterSaveDataFail, 
    loadWorkflowDetailsAddDataRequest, setWorkflowDetailsAddDataSuccess ,setWorkflowDetailsAddDataFail,
    loadTicketDeleteDataRequest, setTicketDeleteDataSuccess, setTicketDeleteDataFail,
    loadWorkflowDeleteDataRequest, setWorkflowDeleteDataSuccess, setWorkflowDeleteDataFail,
    loadTicketBulkUpdateRequest, setTicketBulkUpdateSuccess, setTicketBulkUpdateFail,
    loadTicketErrorLogGetDataRequest, setTicketErrorLogGetDataSuccess, setTicketErrorLogGetDataFail,
    loadTicketEmailExecutionLogGetDataRequest, setTicketEmailExecutionLogGetDataSuccess, setTicketEmailExecutionLogGetDataFail,
    loadTicketDashboardMetricGetDataRequest, setTicketDashboardMetricGetDataFail, setTicketDashboardMetricGetDataSuccess,
    loadTicketAttachmentAddDataRequest, setTicketAttachmentAddDataSuccess, setTicketAttachmentAddDataFail,
    loadTicketAttachmentDeleteDataRequest, setTicketAttachmentDeleteDataSuccess, setTicketAttachmentDeleteDataFail,
}